import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { Button, type ButtonProps } from './Form';

export function CopyButton({
  value,
  label = 'Копировать',
  size = 'sm',
  variant = 'secondary',
}: {
  value: string;
  label?: string;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        // Fallback for non-secure contexts where the async clipboard API is unavailable.
        const area = document.createElement('textarea');
        area.value = value;
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      onClick={copy}
      icon={copied ? <Check className="size-3.5 text-emerald-400" /> : <Copy className="size-3.5" />}
    >
      {copied ? 'Скопировано' : label}
    </Button>
  );
}
